export const CONCLUSION_ROUTE_NAMES = {
  STATEMENT: 'PresentlevelsConclusion',
  ASSESSMENTS: 'PresentlevelsConclusionAssessments',
  GOALS_STRATEGIES: 'PresentlevelsConclusionGoalsStrategies'
}

export const RESULTS_ROUTE_NAME = 'PresentlevelsResults'
